import * as moment from 'moment';

export enum DocumentContainerType {
	Generic = 1,
	BinderExport,
	DigitalLogbook
}

export class Document {
	public documentId: number;
	public name: string;
	public type: string;
	public description?: string;
	public createdOn: string;
	public contentType: string;
	public pdf = 'header-image pdf';
	public groupName: string;
	public downloadDocumentId: number;
	public downloadFileName: string;
   	public thumbnailBase64?: string;
	public documentLabel: string;
	public static clone(doc: Document): Document {
		return Object.assign(new Document(), doc);
	}

	public getName(): string {
		if (!this.name) { return this.name; }
		return this.name.split('.')[0];
	}
	public getDownloadFileName(): string {
		return this.downloadFileName;
	}

	public getDate(): string {
		if (!this.createdOn) { return null; }
		return moment.parseZone(this.createdOn).format('MM/DD/YYYY');
	}
}

export class DocumentContainerDetails {
	public title: string;
	public zipDownloadFileName: string;
	public documentContainerTypeId: DocumentContainerType;
}
export class DocumentGroup {
	public groupName: string;
	public documents: Document[];
}

export class ProposalDocument extends Document {
	public proposalAmount: number;
}

export interface JobDocument {
	jobId: number;
	documentId: number;
	initialFileName: string;
	fileName: string;
	effectiveDate?: Date;
	documentTypeId: number;
	documentTypeName: string;
	jobDocumentId: number;
	createdOn: Date;
	documentConclusionOptionId: number;
	requiresAdditionalDocumentation: boolean;
	documentClassAndTypeMappingId: number;
	documentConclusionOption: string;
	isReviewed: boolean;
	additionalDocIds: number[];
}

export interface DocumentUpdate {
	effectiveDate: string;
	isReviewed: boolean;
	documentConclusionOptionId?: number;
	additionalJobDocIds: string;
	documentConclusionOption: string;
	requiresAdditionalDocumentation: boolean;
	documentTypeMappingId: number;
	documentTypeName: string;
}
